<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" icon>
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ titleComputed }}</span>
            </v-card-title>
            <v-card-subtitle class="text-left mt-2">
                <span>권한: {{ item.canonicalName }}</span>
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row class="mb-5">
                        <v-text-field
                                v-model="requestBody.name"
                                label="권한이름"
                                placeholder="영문자(-대쉬 허용)만 가능하며 2~50자까지 설정할 수 있습니다."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row>
                        <v-textarea
                                v-model="requestBody.description"
                                label="권한설명"
                                rows="5" hide-details outlined></v-textarea>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">닫기</v-btn>
                <v-btn color="blue darken-1" text @click="apply" :disabled="!valid">수정</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {PATH} from "@/constants";
    import {ON_SYSTEM_PERMISSION_RECEIVED} from "@/framework/listeners/listeners";

    export default {
        name: "SystemPermissionEditButton",
        props: {
            item: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                dialog: false,
                requestBody: {
                    name: this.item.name,
                    description: this.item._permission.description,
                    id: this.item.id,
                }
            }
        },
        computed: {
            valid() {
                return /^[A-Z][A-Z-]{0,48}[A-Z]$/.test(this.requestBody.name);
            },

            titleComputed() {
                return "권한 정보 수정";
            },
        },
        watch: {
            'requestBody.name'() {
                this.requestBody.name = this.requestBody.name.toUpperCase();
            },
        },
        methods: {
            apply() {
                this.requestSave();
            },

            requestSave() {
                this.$requestWithOverlay(PATH.SYSTEM_PERMISSION.UPDATE_PERMISSION)
                    .setObject(this.requestBody)
                    .enqueue()
                    .then(res => {
                        this.notifyEvent(ON_SYSTEM_PERMISSION_RECEIVED);
                        this.dialog = false;
                    });
            }
        },
    }
</script>

<style scoped>

</style>